export default "__VITE_ASSET__f2520ba4__"